import '@grandvisionhq/utils';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { getSpecificationItems } from '../utils/get-specification-items.js';

const mapServerToSpecificationsBase = (serverVariant, brand)=>{
    const { erpId , opcoBackendId , sku , variantTypeDetails  } = serverVariant;
    let brandModelCode;
    if ((variantTypeDetails === null || variantTypeDetails === void 0 ? void 0 : variantTypeDetails.__typename) === 'SunglassesVariantTypeDetails' || (variantTypeDetails === null || variantTypeDetails === void 0 ? void 0 : variantTypeDetails.__typename) === 'FrameVariantTypeDetails') {
        var _brandModelCode;
        brandModelCode = (_brandModelCode = variantTypeDetails.brandModelCode) !== null && _brandModelCode !== void 0 ? _brandModelCode : undefined;
    }
    const serverSpecifications = {
        brand,
        erpId,
        opcoBackendId,
        sku,
        brandModelCode
    };
    return getSpecificationItems(serverSpecifications);
};

export { mapServerToSpecificationsBase };
//# sourceMappingURL=map-server-to-specifications-base.js.map
